// ─── Utilities ───────────────────────────────────────────────────────────────

function getAssetUrl(filename) {
  const scripts = document.getElementsByTagName('script');
  for (const script of scripts) {
    if (script.src && script.src.includes('mm-opti-gsi.js')) {
      return script.src.substring(0, script.src.lastIndexOf('/') + 1) + filename;
    }
  }
  return './' + filename;
}

function loadCss(url) {
  if (Array.from(document.querySelectorAll('head link')).some(el => el.href === url)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  document.head.appendChild(link);
}

function load_scripts(urls) {
  const promises = urls.map(url => {
    if (load_scripts.loaded.has(url)) return Promise.resolve();
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.onload = resolve;
      script.src = url;
      document.head.appendChild(script);
    });
  });
  return Promise.all(promises).then(() => urls.forEach(url => load_scripts.loaded.add(url)));
}
load_scripts.loaded = new Set();

// ─── Lenis — chargé dès DOMContentLoaded ─────────────────────────────────────

document.addEventListener('DOMContentLoaded', async () => {
  await load_scripts(['https://cdn.jsdelivr.net/gh/studio-freight/lenis@1.0.25/bundled/lenis.min.js']);
  const lenis = new Lenis();
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
});

// ─── Hero 3D — chargé au DOMContentLoaded ────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(async () => {
    await load_scripts(['https://cdnjs.cloudflare.com/ajax/libs/three.js/110/three.min.js']);
    await load_scripts([getAssetUrl('config_three_hero.js')]);
  }, 500);
});

// ─── Scripts below-fold — chargés au premier scroll ──────────────────────────

async function loadBelowFoldScripts() {
  loadCss('https://cdn.jsdelivr.net/npm/@splidejs/splide@latest/dist/css/splide.min.css');

  await load_scripts([
    'https://cdn.jsdelivr.net/npm/@splidejs/splide@4/dist/js/splide.js',
    'https://unpkg.com/gsap@3/dist/gsap.min.js',
    'https://unpkg.com/gsap@3/dist/ScrollTrigger.min.js'
  ]);

  await load_scripts([
    getAssetUrl('mm_splide_testimonials.js'),
    getAssetUrl('mm_anim_gsap.js')
  ]);
}

window.addEventListener('scroll', loadBelowFoldScripts, { once: true });
